module.exports = __webpack_public_path__ + "518090dbd70e8dd9ae1d110dbd1b2646.svg";